import React from "react";
import classNames from "classnames";

import { downloadUrlFor } from "../common/downloads";

const Download = (props) => {

  const renderDownloadOption = (label, downloadPath) => {
    const { availableDownloadOptions, productIds, onDownloadClick } = props;
    const href = downloadUrlFor(downloadPath, productIds);

    return (
      <li>
        <a className="dropdown-item" href={href} onClick={onDownloadClick}>
          {label}
        </a>
      </li>
    );
  }

  const renderDownloadWithDropupMenu = () => {
    const {
      disabledDownloadAll,
      disabledDropup,
      onDownloadClick,
      downloadPaths,
      availableDownloadOptions,
      productIds,
      translations
    } = props;
    const downloadAllHref = downloadUrlFor(downloadPaths.all, productIds);
    return (
      <div className="btn-group dropup basket__download-btn-group">
        <a
          className={classNames(
            "btn btn-primary basket__download-button--with-dropup",
            {
              disabled: disabledDownloadAll
            }
          )}
          href={downloadAllHref}
          onClick={onDownloadClick}
        >
          {translations.download_all_materials}
        </a>
        <button
          type="button"
          disabled={disabledDropup}
          className="btn btn-primary dropdown-toggle basket__download-dropdown-toggle"
          data-bs-toggle="dropdown"
          aria-expanded="false"
        >
          <span className="visually-hidden">Toggle Dropdown</span>
        </button>
        <ul className="dropdown-menu dropdown-menu-end">
          {availableDownloadOptions.specs &&
            renderDownloadOption(
              translations.download_specs,
              downloadPaths.specs
            )}
          {availableDownloadOptions.revit &&
            renderDownloadOption(
              translations.download_revit,
              downloadPaths.revit
            )}
        </ul>
      </div>
    );
  }

  const renderDownloadButton = () => {
    const {
      disabledDownload,
      onDownloadClick,
      downloadPaths,
      availableDownloadOptions,
      productIds,
      translations
    } = props;
    let downloadHref, downloadLabel;

    if (availableDownloadOptions.specs) {
      downloadHref = downloadUrlFor(downloadPaths.specs, productIds);
      downloadLabel = translations.download_specs;
    } else {
      downloadHref = downloadUrlFor(downloadPaths.revit, productIds);
      downloadLabel = translations.download_revit;
    }
    return (
      <a
        className={classNames("btn btn-primary basket__download-button", {
          disabled: disabledDownload
        })}
        href={downloadHref}
        onClick={onDownloadClick}
      >
        {downloadLabel}
      </a>
    );
  }

  const { availableDownloadOptions } = props;

  if (
    !availableDownloadOptions.all &&
    !availableDownloadOptions.specs &&
    !availableDownloadOptions.revit
  ) {
    return null;
  } else if (availableDownloadOptions.all) {
    return renderDownloadWithDropupMenu();
  } else {
    return renderDownloadButton();
  }
  
}

export default Download;